import { BfiApi, ApiResponse, IApiResponse } from './bfiApi';

export enum ApplicationDashboardStatus {
    Draft = 0,
    Submitted = 1,
    ReadyToClose = 2,
}

export interface Property {
    id: string;
    street1: string;
    street2?: string;
    city: string;
}

export interface IDashboardApplicationItem {
    applicationId: number;
    appId: string;
    properties: Property[];
    missingFiles: string[];

    percentComplete: number;
    createdAt: Date;
    applicationStatus: ApplicationDashboardStatus;
}

export interface IUserNoticeCount {
    total: number;
    unread: number;
}

export class ApplyApi extends BfiApi {
    dashboardApplications(): Promise<ApiResponse<IDashboardApplicationItem[]>> {
        return super.get(`/apply/dashboardApplications`);
    }

    userNotices(): Promise<ApiResponse<IUserNoticeCount>> {
        return super.get(`/notices/user/counts`);
    }

    deleteApplication(applicationId: number): Promise<IApiResponse> {
        return super.post(`apply/deleteApplication/${applicationId}`);
    }
}
